/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frames_To_InsertInputs */



/**
* | output |
* | --- |
* | "Frames to Insert" |
*
* @param {Frames_To_InsertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const frames_to_insert = /** @type {((inputs?: Frames_To_InsertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frames_To_InsertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Images à insérer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzufügende Rahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cornici da inserire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рамки для вставки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcos para insertar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("要插入的框架")
	if (locale === "ja") return /** @type {LocalizedString} */ ("挿入するフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सम्मिलित करने के लिए फ़्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Molduras para inserir")
	return /** @type {LocalizedString} */ ("Frames to Insert")
});